import React from 'react';
import { RendererContext } from '../../context';

export const useIsMacro = () => {
	const { extensionType } = React.useContext(RendererContext);
	return extensionType === 'xen:macro';
};

export const useIsBylineItem = () => {
	const { extensionType } = React.useContext(RendererContext);
	return extensionType === 'confluence:contentBylineItem';
};
